export default function IngredientsCard({ ingredients = [], sideImage, sideAlt }) {
  if (!ingredients.length) return null;

  return (
    <section className="py-10 px-6">
      <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-[1fr_0.9fr] gap-10 items-start">
        <div className="bg-white rounded-2xl shadow-md p-6">
          <h2 className="text-xl font-serif font-bold text-center mb-6">Ingredients</h2>
          <div className="space-y-4">
            {ingredients.map((item) => (
              <div
                key={item.label}
                className="flex items-center justify-between border-b border-dashed border-gray-200 pb-3 last:border-b-0 last:pb-0"
              >
                <span className="text-gray-800 font-medium">{item.label}</span>
                <span className="text-primary-red font-semibold">{item.quantity}</span>
              </div>
            ))}
          </div>
        </div>
        {sideImage ? (
          <div className="bg-white rounded-2xl shadow-md overflow-hidden">
            <div className="aspect-[4/3]">
              <img
                src={sideImage}
                alt={sideAlt || 'Recipe detail'}
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        ) : null}
      </div>
    </section>
  );
}
